import { useState, useEffect } from 'react'

export const useVideoMeta = (url: string): any => {
  const [meta, setMeta] = useState({})

  useEffect(() => {
    if (!url) return
    const video = document.createElement('video')
    video.addEventListener('loadedmetadata', (e) => {
      const {
        videoWidth: width,
        videoHeight: height,
        duration,
      } = e.target as any
      setMeta({ width, height, duration })
    })
    video.src = url
  }, [url])

  return meta
}
